<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>person</mat-icon>
        <div>CAEX</div>
      </div>

      <!--
      <button mat-raised-button (click)='getUserSubscription49()'
        style='font-size: 14px; color:red; margin:10px 0px 0 0;'>
        <mat-icon>add_circle_outline</mat-icon>
      </button>
      -->

    </mat-toolbar>
  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card>

    <div flex justify-content='flex-start' fxLayoutAlign="start">
      <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro' autocomplete="off">

      <button mat-raised-button (click)='gotoNewMember()' style='height: 40px; font-size: 14px; margin:0 0 0 40px;'>
        <mat-icon style='color:blue;'>add_circle_outline</mat-icon>
      </button>

      <button mat-raised-button (click)='exportToCSV()' style='height: 40px; font-size: 14px; margin:0 0 0 40px;'>
        <mat-icon style='color:gray;'>arrow_circle_down</mat-icon>
      </button>

    </div>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSourceCaexMembers" style="margin:10px;" matSort matSortDisableClear=false>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cpf">
        <mat-header-cell *matHeaderCellDef> Doc </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div> {{ element.cpf }} </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Empresa </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.category}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="hasOrder">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Inscrito </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <img *ngIf='element.hasOrder' src='/assets/images/status/img_green.png'>
          <img *ngIf='!element.hasOrder' src='/assets/images/status/img_red.png'>
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='selectedMember(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='delete(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumnsCaexMembers"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumnsCaexMembers;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>